import { SettlementDetail } from '../../models/Entities/SettlementDetails/SettlementDetail';
import { NewSettlementDetail } from '../../models/Entities/SettlementDetails/NewSettlementDetail';
import { ErrorType } from '../../models/HttpError';
import { AppThunkAction } from '../reducers';

// services
import * as Services from '../../services/SettlementDetails.Services';

// actions
import * as Actions from '../actions';

type KnownAction =
    | Actions.SettlementsDeatils.SettlementDetails_GetAll_Request_Action
    | Actions.SettlementsDeatils.SettlementDetails_GetAll_Receive_Action
    | Actions.SettlementsDeatils.SettlementDetails_GetAll_Fail_Action;

export const actionCreators = {
    GetAllSettlementDetails:
        (settlementId: number): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
            var state = getState();
            var token: string = '';

            if (state.oidc?.user) {
                token = state.oidc?.user?.access_token;
            } else {
                dispatch({
                    type: 'SETTLEMENTDETAILS_GETALL_FAIL_ACTION',
                    settlementId: settlementId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Unauthorized',
                        Errors: []
                    }
                });
                return;
            }

            
            dispatch({
                type: 'SETTLEMENTDETAILS_GETALL_REQUEST_ACTION',
                settlementId: settlementId
            });

            Services.GetDetailsBySettlementId(settlementId, token)
            .then((settlementDetails: SettlementDetail[]) => {
                dispatch({
                    type: 'SETTLEMENTDETAILS_GETALL_RECEIVE_ACTION',
                    settlementDetails: settlementDetails,
                    settlementId: settlementId
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: 'SETTLEMENTDETAILS_GETALL_FAIL_ACTION',
                    settlementId: settlementId,
                    error: error
                })
            );
        } 
    };
